import dialogCss from "../../common-styling/Dialog.module.css";

interface Option<T> {
  // Display label for the option
  label: string;
  // Value when the option is selected
  value: T;
}
interface RadioFieldProps<T> {
  // Name of the field as used when submitting the form
  name: string;
  options: Option<T>[];
  selectedValue: T | undefined;
  setSelectedValue: (value: T) => void;
}

// We want to accept any type here that can be converted to a string. Either `Object` or `{}` works,
// but `object` doesn't. Eslint wants the last option, so we disable it here.

/* eslint @typescript-eslint/no-empty-object-type: "off" */
const RadioField = function <T extends {}>({
  name,
  options,
  selectedValue,
  setSelectedValue,
}: RadioFieldProps<T>) {
  function makeOption(option: Option<T>) {
    const id = name + "-" + option.value;
    return (
      <div className={dialogCss.option} key={id}>
        <input
          type="radio"
          required
          id={id}
          name={name}
          value={option.value.toString()}
          checked={option.value === selectedValue}
          onChange={() => setSelectedValue(option.value)}
        />
        <label htmlFor={id}>{option.label}</label>
      </div>
    );
  }
  return <div className={dialogCss.field}>{options.map(makeOption)}</div>;
};

export default RadioField;
